<template>
  <div class="find-vacancy-q-page__side  d-sm-none">
    <picture class="find-vacancy-q-page__side-img">
      <img src="@/assets/img/find-vacancy/side.png"
           alt="find vacancy">
    </picture>
    <h2 class="find-vacancy-q-page__side-title">
      {{ $tFindVacancy('side_title') }}
    </h2>
    <div class="find-vacancy-q-page__side-text  text">
      <p>{{ $tFindVacancy('side_text') }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FindVacancyQPageSide',
    data() {
      return {
        
      }
    }
  }
</script>

<style lang="less">

</style>
